import checkMarkIconSource from './CheckMarkIcon.svg';
import exclamationTriangleOutlinedIconSource from './ExclamationTriangleOutlinedIcon.svg';
import questionMarkIconSource from './QuestionMarkIcon.svg';

export enum DecisionModalIconType {
  LOADING = 'loading',
  ERROR = 'error',
  UNKNOWN = 'unknown',
  DECLINE = 'decline',
  APPROVAL = 'approval',
}

export const DecisionModalIcon = ({
  type,
}: {
  type: DecisionModalIconType;
}) => {
  if (type === DecisionModalIconType.APPROVAL)
    return (
      <div className="mx-auto my-xl flex flex-1 items-center justify-center">
        <img
          src={checkMarkIconSource}
          height="100"
          width="100"
          alt="Checkmark"
        />
      </div>
    );

  if (type === DecisionModalIconType.DECLINE) return null;

  if (type === DecisionModalIconType.UNKNOWN)
    return (
      <div className="mx-auto my-xl flex flex-1 items-center justify-center">
        <img
          src={questionMarkIconSource}
          height="100"
          width="100"
          alt="Questionmark"
        />
      </div>
    );

  if (type === DecisionModalIconType.LOADING)
    return (
      <div className="mx-auto my-xl flex flex-1 items-center justify-center">
        <LoadingSpinner />
      </div>
    );

  if (type === DecisionModalIconType.ERROR)
    return (
      <div className="mx-auto my-xl flex flex-1 items-center justify-center">
        <img
          src={exclamationTriangleOutlinedIconSource}
          height="100"
          width="100"
          alt="Questionmark"
        />
      </div>
    );

  return null;
};

const ringBase =
  'absolute w-[100px] h-[100px] border-[8px] border-transparent rounded-full animate-loading-spinner';

const LoadingSpinner = () => {
  return (
    <div className="relative inline-block h-[100px] w-[100px]">
      <div
        className={`${ringBase} border-t-primary-10`}
        style={{ animationDelay: '-0.45s', zIndex: 4 }}
      />
      <div
        className={`${ringBase} border-t-primary-10`}
        style={{ animationDelay: '-0.3s', zIndex: 3 }}
      />
      <div
        className={`${ringBase} border-t-primary-10`}
        style={{ animationDelay: '-0.15s', zIndex: 2 }}
      />
      <div
        className={`${ringBase} border-t-primary-60`}
        style={{ zIndex: 1 }}
      />
    </div>
  );
};
